import styled from 'styled-components';

const ApiPagination = ({ page, setPage, hasMorePages }) => {
    return (
        <StyledDiv>
            <StyledButton disabled={page === 0} onClick={() => setPage(page - 1)}>
                previous
            </StyledButton>
            <span>Page {page + 1}</span>
            <StyledButton disabled={!hasMorePages} onClick={() => setPage(page + 1)}>
                next
            </StyledButton>
        </StyledDiv>
    );
};

export default ApiPagination;

const StyledButton = styled.button`
    border: 1px solid #d0d5dd;
    border-radius: 8px;
    background-color: white;
    padding: 8px 14px;
    &:disabled {
        opacity: 0.5;
    }
`;

const StyledDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    color: #344054;
    @media screen and (max-width: 1024px) {
        padding-inline: 1rem;
    }
`;
